/* eslint-disable */
// @ts-nocheck
import * as Types from '@xing-com/crate-common-graphql-types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type PeopleStartPageQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type PeopleStartPageQuery = {
  __typename: 'Query';
  peopleStartPage?: {
    __typename: 'PeopleStartPage';
    seeMore?: string | null;
    letterTopLevelPages?: Array<{
      __typename: 'PeopleLetterTopLevelPage';
      letter?: string | null;
      url?: string | null;
      exampleNames?: Array<{
        __typename: 'PeopleUserBagItem';
        name?: string | null;
        url?: string | null;
      } | null> | null;
    } | null> | null;
    cityTopLevelPages?: Array<{
      __typename: 'PeopleCityTopLevelPage';
      cityName?: string | null;
      url?: string | null;
      exampleNames?: Array<{
        __typename: 'PeopleUserBagItem';
        name?: string | null;
        url?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export const PeopleStartPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PeopleStartPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'peopleStartPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'letterTopLevelPages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'letter' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exampleNames' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cityTopLevelPages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cityName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exampleNames' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'seeMore' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PeopleStartPageQuery,
  PeopleStartPageQueryVariables
>;
